<template>
  <a-card>
    <span slot="title">{{ titleCard }}</span>
    <template>
      <div style="display: none">
        <a-select placeholder="Ex: Need Process ... " v-model="activetab" :disabled="true" @change="moreSearch"
          class="width-full" initialValue="process" allowClear>
          <a-select-option value="process">Need Process</a-select-option>
          <a-select-option value="release">BKK Release</a-select-option>
        </a-select>
      </div>
      <a-row :gutter="16">
        <a-col :xs="{ span: 24 }" :lg="{ span: 21 }">
          <a-input-search v-model="search" placeholder="Quick Search" />
        </a-col>
        <a-col :class="getScreen ? 'margin-top' : ''" :xs="{ span: 24 }" :lg="{ span: 3 }">
          <a-button block :icon="advancedsearch == 'display:none' ? 'down' : 'up'" @click="handleshowMore">{{
            advancedsearch == "display:none" ? "More" : "Less" }}</a-button>
        </a-col>
      </a-row>
      <a-row :style="advancedsearch" :gutter="16" class="margin-top">
        <a-col :class="getScreen ? 'margin-bottom-small' : ''" :xs="{ span: 24 }" :lg="{ span: 9 }">
          <div class="m-form-item-wrapper">
            <label>Transaction Date</label>
            <a-range-picker :placeholder="['Start Date', 'End Date']" v-model="transactionDt"
              :format="getDefaultDateFormat" allowClear />
          </div>
        </a-col>
        <a-col :xs="{ span: 24 }" :lg="{ span: 9 }">
          <div v-if="activetab == 'process'" class="m-form-item-wrapper">
            <label>Transaction Type</label>
            <a-select placeholder="Ex: PI ... " v-model="typetransaction" class="width-full" initialValue="all">
              <a-select-option value="all">All transaction</a-select-option>
              <a-select-option value="am">Overbooking</a-select-option>
              <a-select-option value="addendum">Addendum</a-select-option>
              <a-select-option value="financing">Financing</a-select-option>
              <a-select-option value="kas_kecil">Kas Kecil</a-select-option>
              <a-select-option value="klaimpd">Klaim PD</a-select-option>
              <a-select-option value="klaimpp">Klaim PP</a-select-option>
              <a-select-option value="klaimdirektur">Klaim Direktur</a-select-option>
              <a-select-option value="lk_um_pd">Laporan UMPD</a-select-option>
              <a-select-option value="lk_um_pp">Laporan UMPP</a-select-option>
              <a-select-option value="pi">PI</a-select-option>
              <a-select-option value="po">PO</a-select-option>
              <a-select-option value="payment_schedule">Payment Schedule</a-select-option>
              <a-select-option value="umpd">UMPD</a-select-option>
              <a-select-option value="umpp">UMPP</a-select-option>
              <a-select-option value="wo">WO</a-select-option>
              <a-select-option value="bidbond_request">Request Guarantee</a-select-option>
              <a-select-option value="bidbond">Guaranteed Return</a-select-option>
            </a-select>
          </div>
        </a-col>
        <a-col :xs="{ span: 24 }" :lg="{ span: 6 }"> &nbsp; </a-col>
      </a-row>
    </template>

    <a-tabs class="custom-tabs" :activeKey="activetab" @change="handleTab">
      <a-tab-pane style="margin: auto" key="process" v-if="!isAkuntansi">
        <template slot="tab">
          <span>Need Process</span>
          <a-badge class="m-badge m-badge-small" :count="list_process.length" :numberStyle="{ backgroundColor: 'red' }"
            v-if="list_process.length > 0">
          </a-badge>
        </template>
        <div class="loading" v-if="loading.process">
          <a-spin :spinning="loading.process" tip="Loading..."></a-spin>
        </div>
        <a-table v-else key="id_pp2" :columns="column_process" :dataSource="list_process" :pagination="pagination"
          size="small" bordered :scroll="{ x: 900, y: 500 }">
          <template slot="title">
            <div class="table-header">
              <h4 class="margin-remove title">Process List</h4>
              <h4 class="margin-remove">Selected {{ selectedData.length }}</h4>
            </div>
          </template>
          <a slot="no" slot-scope="item" @click="handleLinkManifest(item.jenis, item.id, item.no, item.pembuat)">{{
            item.no }}</a>
          <span slot="value" slot-scope="amount">
            <CurrencyJustified v-if="amount.value" :currencyValue="amount.currency" :valueNumber="amount.value" />
            <div v-else style="text-align: center; width: 100%">-</div>
          </span>
          <span slot="create_by" slot-scope="item">
            <span v-if="item.tlc_updated">
              {{ item.pembuat }} /
              {{
                item.tgl_transaksi
                ? moment(
                  item.tgl_transaksi,
                  getDateTimeStandartFormat
                ).format(getDefaultDateFormat)
                : "-"
              }}
            </span>
            <span v-else> - </span>
          </span>
          <span slot="centang" slot-scope="item">
            <a-checkbox :default-checked="item.dana_sts" :key="item.key" @change="changeActionItem(item)" />
          </span>
        </a-table>
      </a-tab-pane>
      <a-tab-pane tab="BKK List" key="release">
        <div class="loading" v-if="loading.release">
          <a-spin :spinning="loading.release" tip="Loading..."></a-spin>
        </div>
        <a-table v-else :columns="column_release" :dataSource="list_release" key="id_pp1" id="id_pp1" size="small"
          :pagination="pagination" bordered :scroll="{ x: 1000 }">
          <template slot="title">
            <h4 class="margin-remove" slot="title">Release list</h4>
          </template>
          <a slot="no" slot-scope="item" @click="handleLink(item.jenis, item.id)">{{ item.no }}</a>
          <span slot="value" slot-scope="amount">
            <CurrencyJustified v-if="amount.value" :currencyValue="amount.currency" :valueNumber="Number(amount.value)" />
            <div v-else style="text-align: center; width: 100%">-</div>
          </span>
          <span slot="update_by" slot-scope="item">
            <span v-if="item.pembuat">
              {{ item.pembuat }} /
              {{
                item.tgl_transaksi
                ? moment(
                  item.tgl_transaksi,
                  getDateTimeStandartFormat
                ).format(getDefaultDateFormat)
                : "-"
              }}
            </span>
            <span v-else> - </span>
          </span>
          <span slot="action" slot-scope="item">
            <a-button :type="item.need_upload == '0' ? 'default' : 'primary'" @click="handleLink(item.id)"
              :key="item.key">
              {{ item.need_upload == "0" ? "Manifest" : "Upload Bkk" }}
            </a-button>
          </span>
        </a-table>
      </a-tab-pane>
    </a-tabs>
    <a-row :gutter="8" :class="getScreen ? 'm-list-wrapper' : 'd-list-wrapper'">
      <a-col :xs="{ span: 24 }" :lg="{ span: 24 }">
        <div v-if="activetab == 'process'" class="float-right">
          <a-button type="primary" @click="handleGenerate()">
            Generate
          </a-button>
        </div>
      </a-col>
    </a-row>

    <a-modal v-model="editModal" :maskClosable="false" @cancel="handleClose" @ok="handleEditModal" :footer="null">
      <span slot="title">
        <a-icon type="reload" class="margin-right" />Generate UKK
      </span>
      <a-form :form="modalForm">
        <a-form-item label="Type Number">
          <a-radio-group buttonStyle="solid"
            v-decorator="['type_number', { rules: [{ required: true }], initialValue: 'bg' }]" ref="site"
            @change="handlechangegenBKK">
            <a-radio-button type="Radio" value="bg" ref="Radio1">No Billyet Giro</a-radio-button>
            <a-radio-button type="Radio" value="cn" ref="Radio2">Check Number</a-radio-button>
            <a-radio-button type="Radio" value="na" ref="no_atm">
              No Atm
            </a-radio-button>
            <a-radio-button type="Radio" value="ad" ref="autodebet">
              Auto Debet
            </a-radio-button>
          </a-radio-group>
        </a-form-item>
        <a-form-item>
          <a-input autocomplete="off" v-decorator="['no_bg', { rules: [{ required: true }] }]"></a-input>
        </a-form-item>
        <!-- <a-form-item label="Due Date" v-if="changegenBKKval=='bg'">
          <a-date-picker
            placeholder="Select Date"
            v-decorator="['due_date', { rules: [{ required: true }] }]"
            format="DD-MM-YYYY"
            allowClear
          />
        </a-form-item> -->
        <a-form-item label="Trans Date" v-if="changegenBKKval != 'bg'">
          <a-date-picker placeholder="Select Date" v-decorator="['trans_date', { rules: [{ required: true }] }]"
            :disabledDate="disabledDate" format="DD-MM-YYYY" allowClear />
        </a-form-item>
        <a-form-item label="Description">
          <a-input autocomplete="off" v-decorator="['catatan', { rules: [{ required: true }] }]"></a-input>
        </a-form-item>
        <a-form-item label="Bank Account">
          <a-select placeholder="Select Bank Account" v-decorator="[
            'bank_account_id',
            {
              rules: [{ required: true }],
              initialValue: defaultBankGenerateBKK,
            },
          ]" :disabled="defaultBankGenerateBKK ? true : false" showSearch @change="changeBAto" ref="bnkAccount">
            <a-select-option v-for="item in bank" :key="item.bank_account_id">[{{ item.bank_account_id }}] {{
              item.nama_bank }} ({{
    item.kode_rekening
  }})</a-select-option>
          </a-select>
          <div class="m-form-description-small">Account Balance : 
              {{ saldoOnHandBank[0]?formatCurrency(saldoOnHandBank[0].currency,saldoOnHandBank[0].saldo):'-' }} </div>
        </a-form-item>
        <a-form-item label="Exchange Rate" v-if="(saldoOnHandBank[0]?saldoOnHandBank[0].currency:ttlvueCurrency)!=ttlvueCurrency">
          <a-input-number class="m-width-full m-text-align right" 
            ref="exchangeRate"
            v-decorator="['kurs', { rules: [{ required: true }] }]" 
            @change="changeExRate"
            :min="0" />
        </a-form-item>
        <a-form-item label="Upload File Support" v-if="changegenBKKval == 'ad'">
          <a-upload :showUploadList="true" :fileList="push" :beforeUpload="beforeUpload" :remove="handleRemove"
            v-decorator="['upload', { rules: [{ required: true }], valuePropName: 'push' }]">
            <a-button> <a-icon type="upload" />&nbsp;Select File </a-button>
          </a-upload>
        </a-form-item>
        <a-form-item label="Rounding Total Value">
          <a-radio-group v-model="isRoundingBKKValue" @change="isROundingChange" buttonStyle="solid">
            <a-radio-button type="Radio" value="0">No</a-radio-button>
            <a-radio-button type="Radio" value="1">Yes</a-radio-button>
          </a-radio-group>
        </a-form-item>
        <div class="m-price-total">
          <div class="m-display-flex space-between align-middle">
            <h4 class="margin-remove">Total Value</h4>
            <h3 class="margin-remove">{{ res_gen_select_value }}</h3>
          </div>
          <div class="m-display-flex space-between align-middle"
            v-if="(saldoOnHandBank[0]?saldoOnHandBank[0].currency:ttlvueCurrency)!=ttlvueCurrency">
            <span class="margin-remove">Total Value Exchange</span>
            <span class="margin-remove">{{ 
              formatCurrency(saldoOnHandBank[0]?this.saldoOnHandBank[0].currency: "IDR", gen_select_exchange_value) }}</span>
          </div>
        </div>
        <a-button block class="margin-top" type="primary" :loading="previewLoad" @click="previewBKKlist">Preview List BKK</a-button>
        <a-button block class="margin-top" type="danger" :loading="loading.generate" @click="submitGenerate"
          :disabled="!allowSubmitBKK"
          html-type="submit">Submit</a-button>
      </a-form>
    </a-modal>
  </a-card>
</template>
<script>
import { mapGetters } from "vuex";
import axios from "axios";
import moment from "moment";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import shortingArray from "@/mixins/MultishortArray";
import GlobalMethod from "@/mixins/GlobalMethod.js";
import _ from "lodash";

export default {
  name: "BKK",
  props: ["page_type"],
  mixins: [CurrencyFormat, shortingArray, GlobalMethod],
  data() {
    return {
      activetab: "process",
      typetransaction: "all",
      typepage: "",
      list_release: [],
      list_process: [],
      selectedData: [],
      loading: {
        release: false,
        process: false,
        generate: false,
      },
      pagination: {
        onChange: (page) => { },
        pageSize: 20,
        size: "small",
      },
      list_bank: [],
      basedListprocess: [],
      basedListrelease: [],
      transactionDt: [],
      search: undefined,
      editModal: false,
      gen_selected: [],
      previewLoad: false,
      advancedsearch: "display:none",
      changegenBKKval: "bg",
      isRoundingBKKValue: "0",
      push: [],
      ttlvueCurrency: null,
      allowSubmitBKK: false,
      saldoOnHandBank: [],
      gen_select_exchange_value: 0,
      res_gen_select_value: 0
    };
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getDefaultDateFormat",
      "getStandartFormatDate",
      "getDateTimeStandartFormat",
      "getTypePage",
    ]),
    moreSearch: function () {
      let tempData =
        this.activetab == "process"
          ? this.basedListprocess
          : this.basedListrelease;

      if (tempData.length > 0) {
        if (this.search) {
          tempData = tempData.filter(
            (obj) =>
              (obj.no &&
                obj.no.toLowerCase().indexOf(this.search.toLowerCase()) >= 0) ||
              (obj.deskripsi &&
                obj.deskripsi
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0) ||
              (obj.tgl_transaksi &&
                this.moment(obj.tgl_transaksi)
                  .format(this.getDefaultDateFormat)
                  .toString()
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0) ||
              (obj.value &&
                this.formatCurrency(obj.currency, obj.value)
                  .toString()
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0) ||
              (obj.tlc_updated &&
                this.formatCurrency(obj.currency, obj.tlc_updated)
                  .toString()
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0)
          );

          this.intoList(this.activetab, tempData);
        }

        if (this.typetransaction && this.typetransaction !== "all") {
          tempData = tempData.filter(
            (obj) => obj.jenis && obj.jenis == this.typetransaction
          );
        }

        if (this.transactionDt && this.transactionDt.length > 0) {
          let startDt = moment(this.transactionDt[0]).format("YYYY-MM-DD");
          let endDt = moment(this.transactionDt[1]).format("YYYY-MM-DD");

          tempData = tempData.filter(
            (obj) =>
              obj.tgl_transaksi &&
              moment(obj.tgl_transaksi).format("YYYY-MM-DD") >= startDt &&
              moment(obj.tgl_transaksi).format("YYYY-MM-DD") <= endDt
          );
        }
      }
      this.intoList(this.activetab, tempData);
      return true;
    },
    column_process() {
      let { sortedInfo, filteredInfo } = this;
      sortedInfo = sortedInfo || {};
      filteredInfo = filteredInfo || {};

      const kolom = [
        {
          title: "#",
          key: "number",
          dataIndex: "number",
          width: 40,
          align: "center",
        },
        {
          title: "No",
          width: 230,
          key: "no",
          scopedSlots: { customRender: "no" },
        },
        {
          title: "Description",
          key: "deskripsi",
          dataIndex: "deskripsi",
        },

        {
          title: "Value",
          key: "value",
          width: 190,
          scopedSlots: { customRender: "value" },
        },
        {
          title: "Created By",
          key: "create_by",
          align: "center",
          width: 150,
          scopedSlots: { customRender: "create_by" },
        },
        {
          title: "Generate",
          key: "centang",
          width: 80,
          align: "center",
          fixed: "right",
          scopedSlots: { customRender: "centang" },
        },
      ];
      return kolom;
    },
    column_release() {
      let { sortedInfo, filteredInfo } = this;
      sortedInfo = sortedInfo || {};
      filteredInfo = filteredInfo || {};

      const kolom = [
        {
          title: "#",
          key: "number",
          dataIndex: "number",
          width: 25,
          align: "center",
        },
        {
          title: "No",
          width: 70,
          dataIndex: "no",
          key: "no",
        },
        {
          title: "Description",
          key: "deskripsi",
          dataIndex: "deskripsi",
          width: 120,
        },

        {
          title: "Value",
          key: "value",
          width: 75,
          scopedSlots: { customRender: "value" },
        },
        {
          title: "Jenis",
          key: "jns_bkk",
          dataIndex: "jns_bkk",
          width: 40,
        },
        {
          title: "Created By",
          key: "create_by",
          width: 65,
          align: "center",
          scopedSlots: { customRender: "update_by" },
        },
        {
          title: "Action",
          width: 65,
          key: "action",
          align: "center",
          scopedSlots: { customRender: "action" },
        },
      ];
      return kolom;
    },
    column_preview() {
      let { sortedInfo, filteredInfo } = this;
      sortedInfo = sortedInfo || {};
      filteredInfo = filteredInfo || {};

      const kolom = [
        {
          title: "#",
          key: "number",
          dataIndex: "number",
          width: 20,
          align: "center",
        },
        {
          title: "No",
          width: 70,
          dataIndex: "no",
          key: "no",
        },
        {
          title: "Description",
          key: "deskripsi",
          dataIndex: "deskripsi",
          width: 150,
        },

        {
          title: "Value",
          key: "value",
          width: 75,
          scopedSlots: { customRender: "value" },
        },
        {
          title: "Transaction Type",
          key: "transactiontype",
          dataIndex: "jenis",
          width: 65,
          align: "center",
        },
      ];
      return kolom;
    },
    titleCard() {
      return this.typepage.toUpperCase() + " List";
    },
    defaultBankGenerateBKK() {
      let result = undefined;
      if (this.gen_selected.length > 0) {
        result =
          this.gen_selected[0].jenis == "am"
            ? this.gen_selected[0].bank_account_id
            : undefined;
      }
      return result;
    },
    bank() {
      let output = this.list_bank;

      if (this.selectedData.length > 0 && this.selectedData[0].jenis == "am") {
        output = _.filter(
          output,
          (item) => item.currency.indexOf(this.selectedData[0].currency) >= 0
        );
      }

      return output;
    },
    isAkuntansi(){
      return localStorage.getItem("nvpn") === "/akuntansiKeuangan" || localStorage.getItem("nvpn") === "/FinancialControl"
    },
  },
  mounted() {
    if(this.isAkuntansi){
      this.activetab= "release"
    }
    this.fetchData();
  },
  beforeCreate() {
    this.modalForm = this.$form.createForm(this);
  },
  methods: {
    moment,
    fetchData() {
      //console.log("fetcgh");
      this.typetransaction = undefined;
      this.search = undefined;
      if (this.activetab == "release") {
        this.loading.release = true;
      } else {
        this.loading.process = true;
      }
      this.typepage = this.$route.meta.page_type;
      const release = axios({
        method: "get",
        url: this.$serviceUrl + "Bkk",
        params: {
          tab: "bkk list",
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      }).catch((err) => {
        return err;
      });

      const proses = axios({
        method: "get",
        url: this.$serviceUrl + "Bkk",
        params: {
          tab: "need process",
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      }).catch((err) => {
        this.loading.release = false;
        this.loading.process = false;
        let response = Object.assign({}, err.response);
        if (response.data.status == false && response.data.message) {
          this.displayMessageValue("error-other", response.data.message);
        } else {
          let responses = Object.assign({}, err.response.data);
          this.displayMessageValue("error", responses);
        }
        this.$router.push({
          name: "beranda",
        });
        return err;
      });

      const bank = axios({
        method: "get",
        url: this.$serviceUrl + "bkk/bank",
        params: {},
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      }).catch((err) => {
        this.loading.release = false;
        this.loading.process = false;
        return err;
      });

      return new Promise((resolve, reject) => {
        axios
          .all([
            release.catch((err) => {
              return null;
            }),
            proses.catch((err) => {
              return null;
            }),
            bank.catch((err) => {
              return null;
            }),
          ])
          .then((response) => {
            this.list_release =
              response[0].data.message !== "data empty"
                ? response[0].data.data
                : [];
            this.list_process =
              response[1].data.message !== "data empty"
                ? response[1].data.data
                : [];
            this.list_bank = response[2] ? response[2].data.data : [];

            if (
              this.list_process !== undefined &&
              this.list_process.length > 0
            ) {
              for (let index = 0; index < this.list_process.length; index++) {
                let col = [
                  {
                    ...this.list_process[index],
                    number: index + 1,
                    key: index + 1,
                    dana_sts: false,
                    shorting: null,
                  },
                ];
                this.list_process[index] = col[0];
              }
            }
            if (this.list_release.length > 0) {
              for (let index = 0; index < this.list_release.length; index++) {
                let col = [
                  {
                    ...this.list_release[index],
                    number: index + 1,
                    key: index + 1,
                  },
                ];
                this.list_release[index] = col[0];
              }
            }

            this.basedListprocess = this.list_process;
            this.basedListrelease = this.list_release;
            this.loading.release = false;
            this.loading.process = false;
            this.selectedData = [];
            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    intoList(type, value) {
      if (type == "process") {
        if (value.length > 0) {
          value = this.ArrshortMultiCol(value, {
            dana_sts: "desc",
            shorting: "asc",
          });
          for (let index = 0; index < value.length; index++) {
            value[index].number = index + 1;
          }
        }
        this.list_process = value;
      } else {
        this.list_release = value;
      }
    },
    handleTab(val) {
      this.activetab = val;
      if (this.activetab == "release") {
        this.loading.release = true;
        this.typetransaction = "all";
      } else {
        this.loading.process = true;
        this.transactionDt = undefined;
        this.typetransaction = "all";
      }
      this.fetchData();
    },
    handleLink(id_) {
      this.$router.push({ name: "bkkManifestKeu", params: { id: id_ } });
    },
    changeActionItem(item) {
      let iscurr = this.basedListprocess.filter((obj) => obj.dana_sts == true);
      let istypes = iscurr.length > 0 ? iscurr[0].jenis : undefined;
      let isbank = iscurr.length > 0 ? iscurr[0].bank_account_id : undefined;
      let urutan_centang = iscurr.length > 0 ? this.basedListprocess[iscurr.length].shorting + 1 : 1;
      iscurr = iscurr && iscurr.length > 0 ? iscurr[0].currency : undefined;

      for (let index = 0; index < this.basedListprocess.length; index++) {
        if (this.basedListprocess[index].key == item.key) {
          let curr = this.basedListprocess[index].currency;
          let types = this.basedListprocess[index].jenis;
          let bank = this.basedListprocess[index].bank_account_id;

          //validasi
          let step_trans = true;
          let step_bank = true;
          let step_curr = true;

          if (
            istypes &&
            (istypes == "am" || types == "am") &&
            types !== (istypes ? istypes : types)
          ) {
            step_trans = false;
          }

          if (bank !== (isbank ? isbank : bank)) {
            step_bank = false;
          }

          // if (curr !== (iscurr ? iscurr : curr)) {
          //   step_curr = false;
          // }

          if (iscurr == "IDR" && curr != "IDR") {
            step_curr = false;
          } else if (iscurr != "IDR" && istypes != "am") {
            if (iscurr != undefined && curr == "IDR") {
              step_curr = false;
            } else {
              step_curr = true;
            }
          } else if (istypes == "am" && iscurr != curr) {
            step_curr = false;
          }

          if (!step_trans) {
            this.displayMessageValue(
              "error-other",
              "The Type of Transaction is not same!"
            );
          } else if (step_trans && !step_bank) {
            this.displayMessageValue(
              "error-other",
              "The Type of Bank is not same!"
            );
          } else if (step_trans && step_bank && !step_curr) {
            this.displayMessageValue(
              "error-other",
              "The Type of Currency is not same!"
            );
          }

          if (step_trans && step_bank && step_curr) {
            this.basedListprocess[index].dana_sts = !item.dana_sts;
            this.basedListprocess[index].shorting = !item.dana_sts ? urutan_centang : null;
          } else {
            this.loading.process = true;
            this.list_process = [];
            let xval = this.search;
            this.search = "";
            setTimeout(
              function () {
                this.list_process = this.basedListprocess;
                this.search = xval;
                this.moreSearch;
                this.loading.process = false;
              }.bind(this),
              100
            );
          }
          break;
        }
      }
      //sorting
      this.list_process = this.ArrshortMultiCol(this.list_process, {
        dana_sts: "desc",
        shorting: "asc",
      });
      for (let index = 0; index < this.list_process.length; index++) {
        this.list_process[index].number = index + 1;
      }
      this.selectedData = this.basedListprocess.filter(
        (item) => item.dana_sts == true
      );

      this.search;
    },
    handleGenerate() {
      this.gen_selected = this.basedListprocess.filter(
        (item) => item.dana_sts == true
      );

      if (this.gen_selected.length == 0) {
        this.displayMessageValue(
          "error-other",
          "Please select data to generate!"
        );
      } else {
        this.editModal = true;
        this.changegenBKKval = 'bg';
        this.isRoundingBKKValue = "0";
        this.allowSubmitBKK = false
        this.saldoOnHandBank = []
        this.ttlvueCurrency = this.gen_selected[0].currency

        this.gen_select_value()

        if(this.gen_selected[0].jenis=='am'){
          let bnk = this.gen_selected[0].bank_account_id
          this.saldoOnHandBank =  _.filter(this.bank, (item) => item.bank_account_id == bnk)
        }

        this.validateCurrency(null)
      }
    },
    handleClose() {
      this.modalForm.resetFields();
    },
    handleEditModal() { },
    previewBKKlist() {
      this.modalForm.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }
        this.previewLoad = true;

        let currto = _.filter(this.bank, (item) => item.bank_account_id == values.bank_account_id)

        let selected_item = [];
        let total = 0;
        this.gen_selected.forEach((item) => {
          selected_item.push({
            jenis: item.jenis,
            tgl_transaksi: item.tgl_transaksi,
            pembuat: item.pembuat,
            id: item.id,
            no: item.no,
            deskripsi: item.deskripsi,
            currency: item.currency,
            kurs: item.currency == currto[0].currency ? 1 : item.kurs,
            id_ap: item.id_ap,
            value: item.value,
            tlc_updated: item.tlc_updated,
            date_updated: item.date_updated,
          });
          total += parseFloat(item.value);
        });

        let bnk = this.list_bank.filter(
          (item) => item.bank_account_id == values.bank_account_id
        );

        let dat = {};
        let no_bg = "-";
        let no_cek = "-";
        let no_atm = "-";

        if (values.type_number === "bg") {
          no_bg = values.no_bg;
        }

        if (values.type_number === "cn") {
          no_cek = values.no_bg;
        }

        if (values.type_number === "na") {
          no_atm = values.no_bg;
        }

        if (this.gen_selected[0].currency == "IDR") {
          dat = {
            tlc: this.getAuth.username,
            no_bg: no_bg,
            bank_account_id: values.bank_account_id,
            nama_bank: bnk ? bnk[0].nama_bank : "",
            kode_rekening: bnk ? bnk[0].kode_rekening : "",
            catatan: values.catatan,
            no_cek: no_cek,
            no_atm: no_atm,
            selected_item: selected_item,
            value_bkk: this.isRoundingBKKValue == "1" ? Math.ceil(total) : total,
            is_rounding: this.isRoundingBKKValue
          };
        } else {
          dat = {
            tlc: this.getAuth.username,
            no_bg: no_bg,
            bank_account_id: values.bank_account_id,
            nama_bank: bnk ? bnk[0].nama_bank : "",
            currency: bnk ? bnk[0].currency : "",
            kode_rekening: bnk ? bnk[0].kode_rekening : "",
            catatan: values.catatan,
            no_cek: no_cek,
            no_atm: no_atm,
            selected_item: selected_item,
            is_rounding: this.isRoundingBKKValue
          };
        }

        if (values.type_number === "ad") {
          dat.trans_date = moment(values.trans_date).format("DD-MM-YYYY");
          dat.auto_debet = values.no_bg;
        }

        if (values.type_number === "cn" || values.type_number === "na") {
          dat.trans_date = moment(values.trans_date).format("DD-MM-YYYY");
        }

        axios({
          method: "post",
          url: this.$serviceUrl + "bkk/preview_bkk",
          data: {
            head: JSON.parse(JSON.stringify(dat)),
          },
          responseType: "blob",
          processData: false,
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "X-API-KEY": this.getAuth.apikey,
            "Content-Type": "application/json",
          },
        })
          .then((response) => {
            //console.log(response);
            this.previewLoad = false;
            let blob = new Blob([response.data], { type: "application/pdf" }),
              url = window.URL.createObjectURL(blob);
            window.open(url, "_blank");
          })
          .catch((err) => {
            if (err.response && err.response.status === 404) {
              this.displayMessage("404");
            } else if (err.response) {
              let responses = Object.assign({}, err.response);
              this.displayMessageValue("error", responses);
            }
            this.previewLoad = false;
            this.$router.go(-1);
          });
      });
    },
    submitGenerate() {
      this.modalForm.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }

        this.loading.generate = true;

        let currto = _.filter(this.bank, (item) => item.bank_account_id == values.bank_account_id)

        let selected_item = [];
        let total = 0;
        this.gen_selected.forEach((item) => {
          selected_item.push({
            jenis: item.jenis,
            tgl_transaksi: item.tgl_transaksi,
            pembuat: item.pembuat,
            id: item.id,
            no: item.no,
            deskripsi: item.deskripsi,
            currency: item.currency,
            kurs: item.currency == currto[0].currency ? 1 : item.kurs,
            id_ap: item.id_ap,
            value: item.value,
            tlc_updated: item.tlc_updated,
            date_updated: item.date_updated,
          });
          total += parseFloat(item.value);
        });
        let no_bg = "-";
        let no_cek = "-";
        let no_atm = "-";

        if (values.type_number === "bg") {
          no_bg = values.no_bg;
        }

        if (values.type_number === "cn") {
          no_cek = values.no_bg;
        }

        if (values.type_number === "na") {
          no_atm = values.no_bg;
        }

        let data = new FormData();

        if (this.gen_selected[0].currency == "IDR") {
          data.append("tlc", this.getAuth.username);
          data.append("no_bg", no_bg);
          data.append("bank_account_id", values.bank_account_id);
          data.append("catatan", values.catatan);
          data.append("no_cek", no_cek);
          data.append("no_atm", no_atm);
          data.append("selected_item", JSON.stringify(selected_item));
          data.append("value_bkk", total);
          data.append("is_rounding", this.isRoundingBKKValue);
        } else {
          data.append("tlc", this.getAuth.username);
          data.append("no_bg", no_bg);
          data.append("bank_account_id", values.bank_account_id);
          data.append("catatan", values.catatan);
          data.append("no_cek", no_cek);
          data.append("no_atm", no_atm);
          data.append("selected_item", JSON.stringify(selected_item));
          data.append("is_rounding", this.isRoundingBKKValue);
        }

        if (values.type_number === "ad") {
          data.append("trans_date", moment(values.trans_date).format("YYYY-MM-DD"));
          data.append("auto_debet", values.no_bg);
          data.append("file_support", this.push[0]);
        } else {
          data.append("auto_debet", "-");
        }

        if (values.type_number === "cn" || values.type_number === "na") {
          data.append("trans_date", moment(values.trans_date).format("YYYY-MM-DD"));
        }

        axios({
          method: "post",
          url: this.$serviceUrl + "bkk/submit_bkk",
          processData: false,
          data: data,
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "Content-Type": "application/json",
            "X-API-KEY": this.getAuth.apikey,
          },
        })
          .then((response) => {
            this.displayMessageValue("success-other", response.data.message);
            this.loading.generate = false;
            this.editModal = false;
            this.fetchData();
            this.activetab = "release";

            this.search = undefined;
            this.transactionDt = undefined;
            this.typetransaction = "all";
            this.push = [];
          })
          .catch((err) => {
            this.loading.generate = false;
            let responses = Object.assign({}, err.response);
            this.displayMessageValue("error", responses);
          });
        this.modalForm.resetFields();
      });
    },
    handleLinkManifest(jenis, id_, no_trans, pembuat) {
      let manifest = "";
      if (jenis == "tax_release") {
        let ids = no_trans.split("/")
        let tipe = ids[2]
        if (tipe.toLowerCase() == "pph21") {
          tipe = "pph21"
        } else if (tipe.toLowerCase() == "ppn") {
          tipe = "ppn"
        } else if (tipe.toLowerCase() == "pphuni") {
          tipe = "unifikasi"
        }
        ids = ids[1].split(".")
        if (ids[0] == 'SPT') {
          manifest = "SPTManifest";
          this.$router.push({ name: manifest, params: { id: id_, tipe: tipe } });
        } else {
          manifest = "ManifestPIRelease";
          this.$router.push({ name: manifest, params: { id: id_, tipe, tlc: this.getAuth.username, user_pembuat: pembuat } });
        }
      } else {
        if (jenis == "pi") {
          manifest = "PiManifest";
        } else if (jenis == "pi_release") {
          manifest = "ManifestPIRelease";
        } else if (jenis == "umpp") {
          manifest = "UmppManifest";
        } else if (jenis == "umpd") {
          manifest = "umpd_manifest";
        } else if (jenis == "klaimpd") {
          manifest = "manifestKlaimPd";
        } else if (jenis == "klaimpp") {
          manifest = "manifestKlaimPp";
        } else if (jenis == "klaimdirektur") {
          manifest = "manifestDirectur";
        } else if (jenis == "po") {
          manifest = "PoManifest";
        } else if (jenis == "wo") {
          manifest = "manifestWO";
        } else if (jenis == "pp") {
          manifest = "manifestPp";
        } else if (jenis == "kas_kecil") {
          manifest = "manifestLaporanKasKecil";
        } else if (jenis == "sppd") {
          manifest = "manifest";
        } else if (jenis == "lk_um_pp") {
          manifest = "lapUmppManifest";
        } else if (jenis == "lk_um_pd") {
          manifest = "manifestLaporanUmpd";
        } else if (jenis == "addendum") {
          manifest = "AddendumManifest";
        } else if (jenis == "am") {
          manifest = "AccountMutationManifestKeu";
        } else if (jenis == "payment_schedule") {
          manifest = "PaymentScheduleManifestKeu";
        } else if (jenis == "financing") {
          manifest = "financing-manifest";
        } else if (jenis == "guarantee_fund") {
          manifest = "bidBond-manifestKeu";
        } else if (jenis == "bidbond_request") {
          manifest = "bidBondRequest-manifestKeu";
        } else if (jenis == "bidbond") {
          manifest = "bidBond-manifest";
        } else if (jenis == "refund_guarantee") {
          manifest = "guaranteeRefund-manifestKeu";
        } else if (jenis == "other_outcome") {
          manifest = "OtherOutcomeManifestKeu";
        } else if (jenis == "klaim_cc") {
          manifest = "manifestKlaimCC";
        } else if (jenis == "klaim_cc_pp") {
          manifest = "manifestKlaimCCPp";
        } else if (jenis == "klaim_cc_pd") {
          manifest = "manifestCCKlaimPd";
        } else {
          manifest = "Manifest";
        }
        this.$router.push({ name: manifest, params: { id: id_ } });
      }
    },
    handleshowMore() {
      if (this.advancedsearch == "display:none") {
        this.advancedsearch = "display:block";
      } else {
        this.advancedsearch = "display:none";
      }
    },
    handlechangegenBKK(val) {
      this.changegenBKKval = val.target.value;
      if (this.changegenBKKval != 'ad')
        this.push = [];

      if (this.changegenBKKval == "cn" || this.changegenBKKval == "na") {
        this.$nextTick(function () {
          this.modalForm.setFieldsValue({
            trans_date: moment(),
          });
        });
      } else if (this.changegenBKKval == "ad") {
        this.$nextTick(function () {
          this.modalForm.setFieldsValue({
            trans_date: null,
          });
        });
      }
    },
    isROundingChange() {
      this.gen_select_value();
    },
    beforeUpload(file) {
      const FileSize = file.size / 1024 / 1024;
      if (FileSize > 2) {
        this.displayMessage("large-file-2mb");
      } else {
        this.push = [file];
        return false;
      }
    },
    handleRemove() {
      this.push = [];
    },
    disabledDate(current) {
      // Can not select days before today and today
      return this.changegenBKKval == "ad" ? false : (current && current < moment().subtract(1, 'days'));
    },
    changeBAto(val) {
      let bankCurr = _.filter(this.bank, (item) => item.bank_account_id == val)
      // this.ttlvueCurrency = bankCurr[0].currency
      this.ttlvueCurrency = this.gen_selected[0].currency
      this.saldoOnHandBank = bankCurr
      this.validateCurrency(null)
    },
    validateCurrency(val){
      let tempcrr = this.saldoOnHandBank[0]?this.saldoOnHandBank[0].currency: "IDR"
      let temprp = new Intl.NumberFormat('id-ID', {style: 'currency', currency: tempcrr}).format(0).replaceAll("0,00","");
      // let res = this.res_gen_select_value.replace(/[^0-9]/g, '');
      let res = this.res_gen_select_value.replaceAll(".","").replaceAll(temprp,"").replaceAll(",",".")
      if(this.ttlvueCurrency!=(this.saldoOnHandBank[0]?this.saldoOnHandBank[0].currency:'IDR')){
        res = _.sumBy(this.gen_selected, function (val) {
          return Number(val.value)
        });
      }

      this.gen_select_exchange_value = res*(val?val:1)
      if((this.saldoOnHandBank[0]?Number(this.saldoOnHandBank[0].saldo):0) >= 
        this.gen_select_exchange_value?Number(this.gen_select_exchange_value):0){
        this.allowSubmitBKK = true
      }else{
        this.allowSubmitBKK = false
      }
    },
    changeExRate(val){
      this.validateCurrency(val)
    },
    gen_select_value() {
      let hasil = 0;
      let curr = "";
      let valueCurr;
      let jns = "";
      if (this.gen_selected.length > 0) {
        jns = this.gen_selected[0].jenis;
        this.gen_selected.forEach((element) => {
          hasil += parseFloat(element.value);
          curr = element.currency;
        });
      }

      if (this.isRoundingBKKValue == "1") {
        hasil = Math.ceil(hasil);
      }

      if (jns == "am") {
        valueCurr =
          this.gen_selected.length > 0
            ? this.formatCurrency(this.gen_selected[0].currency, hasil)
            : 0;
      } else {
        if (curr === "IDR" || (curr != "IDR" && curr==this.gen_selected[0].currency)) {
          valueCurr =
            this.gen_selected.length > 0
              ? this.formatCurrency(this.ttlvueCurrency, hasil)
              : 0;
        } else {

          valueCurr = this.formatCurrency(this.ttlvueCurrency, 0);
        }
      }

      this.res_gen_select_value = valueCurr;
    },
  },
};
</script>

<style lang="less" scoped>
.float-right {
  padding: @padding;
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
}

.custom-tabs {
  border-top: 1px solid darken(white, 5);
  margin-top: @margin / 2;
}

.table-header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  .title {
    color: @color-secondary;
  }
}
</style>
